const countProductReferences = (value, productId, seen = new WeakSet()) => {
  if (Array.isArray(value)) {
    return value.reduce((sum, entry) => sum + countProductReferences(entry, productId, seen), 0);
  }
  if (!value || typeof value !== 'object') return 0;
  if (seen.has(value)) return 0;
  seen.add(value);

  const ownReference = value.productId === productId ? 1 : 0;
  return ownReference + Object.values(value).reduce(
    (sum, entry) => sum + countProductReferences(entry, productId, seen),
    0
  );
};

export const findProductRecipeDependencies = (products, productId) => (
  (Array.isArray(products) ? products : [])
    .filter((product) => product?.id !== productId && product?.deleted !== true)
    .map((product) => ({
      id: product.id,
      name: product.name || 'Producto sin nombre',
      referenceCount: countProductReferences(product?.config?.recipe, productId),
    }))
    .filter((product) => product.referenceCount > 0)
    .sort((a, b) => a.name.localeCompare(b.name, 'es', { sensitivity: 'base' }))
);

